import { cn } from "@/lib/utils";
import { siteConfig } from "@/lib/seo/metadata";
import { CtaLink } from "@/shared/ui/cta-link";
import { HeroShell } from "@/shared/layout/HeroShell";

type ForAgenciesHeroProps = React.HTMLAttributes<HTMLElement>;

export function ForAgenciesHero({ className, ...props }: ForAgenciesHeroProps) {
  return (
    <HeroShell
      className={className}
      innerClassName="min-h-[var(--layout-platform-card-height-xl)] md:h-[var(--layout-platform-card-height-xl)]"
      {...props}
    >
      <div className="relative mx-auto flex w-full max-w-(--layout-hero-content-width) flex-col items-center gap-6 px-6 pb-10 pt-28 text-center md:absolute md:left-1/2 md:top-[60%] md:max-w-none md:-translate-x-1/2 md:-translate-y-1/2 md:py-0">
        <h1 className="text-display-hero text-(--color-text-primary) md:whitespace-nowrap">For Media Buyers</h1>
        <p className="text-heading-sm text-(--color-text-primary)">
          Plan and verify organic short-form reach across Shorts, TikTok, and Reels.
        </p>
        <div className="mt-2 flex flex-col items-center gap-3 sm:flex-row md:mt-4">
          <CtaLink analyticsElementId="for-agencies-hero:launch-cta" to="/signin" className={cn("px-8")}>
            Launch a campaign
          </CtaLink>
          <CtaLink
            analyticsElementId="for-agencies-hero:contact-cta"
            href={siteConfig.contact.calendly}
            target="_blank"
            rel="noopener noreferrer"
            className={cn("px-8")}
          >
            Contact Us
          </CtaLink>
        </div>
      </div>
    </HeroShell>
  );
}
